import React, { useState } from 'react'
import { Control } from 'react-hook-form'

import s from './styles.module.scss'

import {
  ISearchClientRequests,
  ISelectProposalForm,
} from '../../modal-select-proposal.types'
import { useDebounceFunction } from '../../../../../hooks/useDebounced'
import ControlledSelectField from '../../../../forms/select-field/ControlledSelectField'
import { ISelectOption } from '../../../../forms/select-field/SelectField'

interface ISelectClientRequestProps {
  control: Control<ISelectProposalForm, any>
  getClientRequests?: (variables: {
    q: string
    onlyTravelTypeWithHousing: boolean
  }) => Promise<ISearchClientRequests[]>
}

export const SelectClientRequest = ({
  control,
  getClientRequests,
}: ISelectClientRequestProps) => {
  const [selectOptions, setSelectOptions] = useState<ISelectOption[]>([])
  const { debounce } = useDebounceFunction()

  const onInputChange = (value: string) => {
    const fetchAndSetClientRequests = async () => {
      if (!getClientRequests) {
        return
      }
      const res = await getClientRequests({
        q: value,
        onlyTravelTypeWithHousing: true,
      })
      setSelectOptions(
        res.map((clientRequest) => {
          return {
            value: clientRequest._id,
            label: `${clientRequest.company?.name} ${clientRequest.readableId}`,
          }
        }),
      )
    }
    debounce(fetchAndSetClientRequests, 500)
  }

  return (
    <div className={s.container}>
      <h3 className={s.title}>Ajouter à une transaction</h3>
      <ControlledSelectField
        control={control}
        name='clientRequestId'
        options={selectOptions}
        rules={{
          required: 'Veuillez sélectionner une demande client',
        }}
        placeholder='Choisir une transaction'
        onInputChange={onInputChange}
        className={s.selectField}
      />
    </div>
  )
}
